import { ASSET_TYPE, MESSAGE_CONTENT_TYPE } from "@home-health-notify/domain";
import { CircularProgress, Link, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import {
  ChatContext,
  formatChatMessageTime,
  useGetChatAssets,
} from "hhn-commons";
import * as React from "react";
import EmptyRecordView from "../../../../../common/EmptyRecordView";
import ScrollListContainer from "../../../../../common/ScrollListContainer";
import UserImage from "../../../../../common/user/UserImage";
import { UserFullName } from "../../../../../common/user/UserText";
import { LinkContentWrapper } from "../../../../../message/messageType/contentType/LinkContent.style";
import {
  DocumentAssetsWrapper,
  DocumentItemHeader,
  DocumentPaper,
} from "./DocumentAssets";

const LinksAssets = () => {
  const { isChatAssetsLoading: isLoading, getChatAssets } = useGetChatAssets(
    ASSET_TYPE.LINK,
  );

  const { chat } = React.useContext(ChatContext);

  return (
    <ScrollListContainer
      dataTestId={"asset-" + ASSET_TYPE.LINK.toLowerCase()}
      isLoading={isLoading}
      restTop={115}
      onScrollCallback={getChatAssets}
    >
      <>
        <Box sx={{ width: "100%", p: 1, m: 0 }} data-testid="asset-links-list">
          {chat?.groupAssets &&
            chat.groupAssets.data.map((data, index) => {
              const message = data.getMessage();
              return (
                <DocumentPaper
                  key={message.id + index}
                  data-testid="asset-link-list-item"
                >
                  {message.contentType === MESSAGE_CONTENT_TYPE.LINK &&
                    message.body.length > 0 && (
                      <DocumentAssetsWrapper>
                        <DocumentItemHeader>
                          <UserImage userId={message.from} />
                          <Box>
                            <UserFullName userId={message.from} />
                            <Typography>
                              {formatChatMessageTime(message.createdAt)}
                            </Typography>
                          </Box>
                        </DocumentItemHeader>
                        {(message.links ?? []).map((link, index) => (
                          <LinkContentWrapper key={index}>
                            <Link href={link} underline="none" target="_blank">
                              {link}
                            </Link>
                          </LinkContentWrapper>
                        ))}
                      </DocumentAssetsWrapper>
                    )}
                </DocumentPaper>
              );
            })}
        </Box>
        {isLoading && (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "170px",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        {!isLoading &&
          chat?.groupAssets &&
          chat.groupAssets.data.length <= 0 && <EmptyRecordView />}
      </>
    </ScrollListContainer>
  );
};

export default LinksAssets;
